import { render } from "./DocumentToolbar.vue?vue&type=template&id=7d36430e&scoped=true"
import script from "./DocumentToolbar.vue?vue&type=script&lang=js"
export * from "./DocumentToolbar.vue?vue&type=script&lang=js"

import "../../assets/scss/document_toolbar.scss?vue&type=style&index=0&id=7d36430e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d36430e"]])

export default __exports__